import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Signature from '../../components/Signature';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      console.log('🔐 Tentative de connexion avec:', formData.email);
      
      // Utiliser la fonction login du contexte qui gère tout automatiquement
      await login(formData);
      
      console.log('✅ Connexion réussie, redirection...');
      // Rediriger vers le dashboard
      navigate('/dashboard');
    } catch (err) {
      console.error('❌ Erreur de connexion:', err);
      console.error('❌ Réponse erreur:', err.response?.data);
      const errorMessage = err.response?.data?.message || err.message || 'Impossible de se connecter au serveur';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography component="h1" variant="h4" gutterBottom>
              Firdaws BO
            </Typography>
            <Typography component="h2" variant="h6" color="text.secondary" gutterBottom>
              Connexion Administrateur
            </Typography>
            
            {error && (
              <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Adresse email"
                name="email"
                autoComplete="email"
                autoFocus
                value={formData.email}
                onChange={handleChange}
                disabled={loading}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Mot de passe"
                type="password"
                id="password"
                autoComplete="current-password"
                value={formData.password}
                onChange={handleChange}
                disabled={loading}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Se connecter'}
              </Button>
            </Box>

            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary">
                Comptes de test disponibles :
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Admin: admin@firdaws.com / admin123
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Étudiant: ahmed@example.com / student123
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
      <Signature sx={{ mt: 4 }} />
    </Container>
  );
};

export default Login;